import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface HashModalDataType {
  index: number;
  clickedTab: string;
}

interface RecentResultDetailState {
  isOpen: boolean;
  timeRemaining: number;
  inPlayHash: string;
  copied: number;
  timeStamp: string;
  resultMul: number;
  hashKey: string;
  hashResult: string;
  hashModalData: HashModalDataType;
}

const initialState: RecentResultDetailState = {
  isOpen: false,
  timeRemaining: 0,
  inPlayHash: '',
  copied: 0,
  timeStamp: '',
  resultMul: 0,
  hashKey: '',
  hashResult: '',
  hashModalData: {index: -500000, clickedTab: "footer"}
};

export const recentResultDetailStateSlice = createSlice({
  name: 'recentResultDetailState',
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = false;
    },
    setTimeRemaining: (state, action: PayloadAction<number>) => {
      state.timeRemaining = action.payload;
    },
    reduceTimeRemaining: (state) => {
      state.timeRemaining = state.timeRemaining - 1;
    },
    setInPlayHash: (state, action: PayloadAction<string>) => {
      state.inPlayHash = action.payload.toString();
    },
    setCopied: (state, action: PayloadAction<number>) => {
      state.copied = action.payload;
    },
    setTimeStamp: (state, action: PayloadAction<string>) => {
      state.timeStamp = action.payload;
    },
    setResultMultiplier: (state, action: PayloadAction<number>) => {
      state.resultMul = action.payload;
    },
    setHashKey: (state, action: PayloadAction<string>) => {
      state.hashKey = action.payload;
    },
    setHashResult: (state, action: PayloadAction<string>) => {
      state.hashResult = action.payload;
    },
    setHashModalData: (state, action: PayloadAction<HashModalDataType>) => {
      state.hashModalData = action.payload;
    }
  },
});

export const recentResultDetailStateActions = recentResultDetailStateSlice.actions;
